import moment from 'moment'

export default (startDate, endDate) => {
    if(!startDate || !endDate) return null;
    
    const d1 = moment(endDate);
    const d2 = moment(startDate);
    return d1.diff(d2, 'days') + 1;
}